import type { SiteGroup } from "../site_groups/SiteGroupsApi";

export function getSiteGroupNavigation(
  groups: SiteGroup[],
  siteId: string,
  dashboardGroupId: number | undefined,
  siteLabel: (siteId: string) => string
) {
  const compareLabels = (a: string, b: string) =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
  return groups
    .filter((group) =>
      dashboardGroupId !== undefined ? group.id === dashboardGroupId : group.siteIds.includes(siteId)
    )
    .sort((a, b) => compareLabels(a.name, b.name))
    .map((group) => ({
      ...group,
      siteIds: [...group.siteIds].sort((a, b) => compareLabels(siteLabel(a), siteLabel(b))),
    }));
}
